import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Save the attempted path and any state in the redirect
    return (
      <Navigate
        to="/login"
        state={{
          from: location.pathname,
          search: location.search,
          message: "Please login to access this page",
          previousState: location.state,
        }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
